import commonUtil from '../../../utils/commonUtil';

export const GET_GLOBAL_DATA = 'GET_GLOBAL_DATA';
export const GET_GLOBAL_DATA_SUCCESS = 'GET_GLOBAL_DATA_SUCCESS';
export const GET_GLOBAL_DATA_LOAD_FAIL = 'GET_GLOBAL_DATA_LOAD_FAIL';

export function loadGlobalData(globalState) {
  return globalState.globalData && globalState.globalData.loaded;
}

export function getGlobalData() {
  const userEnteredData = {};
  userEnteredData.brand = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();
  userEnteredData.locale = 'es-mx';

  return {
    types: [
      GET_GLOBAL_DATA,
      GET_GLOBAL_DATA_SUCCESS,
      GET_GLOBAL_DATA_LOAD_FAIL,
    ],
    promise: (client) =>
      client.get(
        '/api/getGlobalData?' + commonUtil.objectToQueryParams(userEnteredData),
      ),
  };
}
